import React, { useState, useEffect, useContext } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate, Link } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import OTPInput from "otp-input-react";
import { contentContext } from "../context/contentContext";
import logo from '../assets/images/Dadi-logo.svg';
import rotate_right from '../assets/images/rotate_right.svg';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import signinImage from "../assets/images/signing-img.svg";
import signinImage1 from "../assets/images/signing-img1.svg";
import rotateIconorange from "../assets/images/rotate_right-1.svg"
let { lambda, country, appname } = window.app;

const SignIn = () => {
  let { id } = useParams();
  const [pwd, setPwd] = useState('');
  const [emailId, setEmailId] = useState("")
  const [email, setEmail] = useState("");
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [config, setConfig] = useState({});
  const navigate = useNavigate();
  const [activeLoad, setActiveLoad] = useState("");

  const [image, setImg] = useState('');
  const [showSessionPopup, setShowSessionPopup] = useState(false);
  const [BtnLoader, setBtnLoader] = useState('');
  const [otpclass, setOtpClass] = useState(false);
  const [otp, setShowOtp] = useState(false)
  const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, setMenuLearning, GetUserDataContext, menuLearningActive, processObject, sortTableAlpha, arrow, sortTableByDate, userData, companysearch, setCompanySearch, companyadvSearch, setCompanyAdvSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, setActiveMenuObj, GetTimeActivity } = useContext(contentContext)
  const [signinOtp, setSigninOtp] = useState("");
  const [visibility, setVisibility] = useState({ newpwd: false, cnfrmpwd: false, showpassword: false });
  const [componentType, setComponentType] = useState("");
  const [resendActive, setResendActive] = useState(false);
  const [checkUserType, setCheckUserType] = useState("");




  useEffect(() => {

    if (window.site === undefined) {
      setTimeout(() => {
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
          setImg(window.site.common.imageCloudfront)
        }
      }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
      setImg(window.site.common.imageCloudfront)
    }


  }, [window.site]);


  useEffect(() => {
    const token = localStorage.getItem("token");
    const isFreshLogin = localStorage.getItem("freshLogin") === "true";

    // Only redirect on refresh, not immediately after login
    if (token && !isFreshLogin) {
      if (userData?.userType === "DOCTOR") {
        navigate("/cpc");
      } else if (userData?.userType && userData.userType !== "DOCTOR") {
        navigate("/dashboard");
      }
    }

    // Reset the flag after the first run
    localStorage.setItem("freshLogin", "false");
  }, [userData]);


  const handleKeypress = (e) => {
    //it triggers by pressing the enter key

    if ((e.key === "Enter")) {
      setTimeout(function () {
        handleSignIn();
        console.log("called");
      }, 1000);
    }
  };

  const handleSignIn = (e) => {

    console.log("called1");
    if (email === "" && pwd === "") {
      setError("Please enter email and password");
      setTimeout(function () { setError("") }, 3000);
    }
    else if (email === "") {
      setError("Please enter email");
      setTimeout(function () { setError("") }, 3000);
    }
    else if (pwd === "") {
      setError("Please enter password");
      setTimeout(function () { setError("") }, 3000);
    }
    if (email && pwd) {
      setBtnLoader("loginpwd")
      SigninPwd();
    }
  }

  const AddNotify = () => toast.success('mail sent successfully', {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  },)

  const clentForgotPassword = async () => {
    try {
      setActiveLoad("forgotpwd")
      const response = await tmdbApi.ForgotPassword({
        "emailId": email
      });
      console.log(response);
      if (response.statusCode === 200) {
        // setSuccess(true);
        if (response.result === "PENDING VERIFICATION") {
          setError("Please Complete SignUp Process");
          setTimeout(function () { navigate("/signup") }, 3000);

        } else if (response.result === "PENDING REGISTRATION") {
          setError("Please Complete SignUp Process");
          setTimeout(function () { navigate("/signup") }, 3000);

        } else if (response.result === "Client not found") {
          setError("User not Found. Please SignUp ");
          setTimeout(function () { setError("") }, 3000);
        } else if (response.result === "user not found") {
          setError("User not Found. Please SignUp ");
          setTimeout(function () { setError("") }, 3000);
        } else if (response.result === "PENDING APPROVAL") {
          // setError("Please Wait For Admin Approval");
          navigate("/thankyou")
          setTimeout(function () { setError("") }, 3000);
        } else if (response.result === "Email does not exists") {
          setError("Email does not exists");
          setTimeout(function () { setError("") }, 3000);
        }

        else if (response?.result === 'mail sent successfully') {
          console.log("successssssssssssssss")
          AddNotify();
        }
        setActiveLoad("")
      } else {
        setActiveLoad("")
        setError("invalid Email Id");
        setTimeout(function () { setError("") }, 3000);
      }

    } catch {
      console.log("error");
      setBtnLoader("")
      setError("Please enter email id");
      setTimeout(function () { setError("") }, 3000);
    } finally {
      setActiveLoad("")
      setBtnLoader("")
      setError("Please enter email id");
      setTimeout(function () { setError("") }, 3000);
    }
  };
  // console.log(email, 'emailllll')
  const emailValidation = (e) => {
    let flag = true;
    const regEx = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}(.[a-zA-Z{2,8}])?/g;
    if (regEx.test(email)) {
      setError("");

    } else if (!regEx.test(email) && email !== "") {
      setError("Email is Not Valid");
      setTimeout(function () { setError("") }, 3000);
      flag = false;
    }
    if (email === "") {
      setError("Please Enter Email");
      setTimeout(function () { setError("") }, 3000);
      flag = false;
    }
    return flag

  }


  const signOtp = async () => {

    try {
      let obj = {
        "email": email,
        "logintype": "otp",
        "userType": checkUserType,
        "otp": Number(signinOtp),
      }
      if (localStorage.getItem("cpcid") && localStorage.getItem("cpcid") !== "null") {
        obj["cpcid"] = localStorage.getItem("cpcid")
      }
      //   setActiveLoad("loginOtp")
      const response = await tmdbApi.signin(obj);
      if (response.result === "password not set") {
        localStorage.setItem("clientid", response.result.clientid);
        navigate("/generatepwd/?id=" + response.result.clientid);
      } else if (response?.result === "Invalid otp entered") {
        setOtpClass(true); // Handle invalid OTP
      } else if (response?.result === "Session Already Exists") {
        signoutsession()
        setShowSessionPopup(true)
        // navigate("/")
        setBtnLoader("")
        setActiveLoad("")
      } else if (response.result && response.result.userid) {
        // console.log('elseeeeeee block of signin')
        localStorage.setItem("cpcid", null);
        let userType = response.result.userType;

        localStorage.setItem("token", response.result.token);
        localStorage.setItem("email", email);

        localStorage.setItem("userId", response.result.userid);
        localStorage.setItem("userType", userType);
        localStorage.setItem("login", "setlogin");
        localStorage.setItem("name", response?.result.name);
        localStorage.setItem("contact", response?.result.phoneNumber);

        // console.log('response.result.clientid', response.result.clientid)
        let currentDate = new Date().toJSON();
        localStorage.setItem("currentSessionClientTime", currentDate);
        const plan = localStorage.getItem('selectedPlan')
        const libraryId = localStorage.getItem("libraryId")
        const moduleid = localStorage.getItem("moduleid");
        if (userType === "DOCTOR" && moduleid && moduleid !== "null" && moduleid !== "undefined") {

          GetUserDataContext()

          fetchLibraryData(moduleid)
        } else if (userType === "DOCTOR" && plan && plan !== "null" && plan !== "undefined") {
          GetUserDataContext()
          navigate("/fellowship")
        } else if (userType === "DOCTOR" && libraryId && libraryId !== "null" && libraryId !== "undefined") {
          GetUserDataContext()
          navigate('/subscription')
        } else {
          GetUserDataContext()
          tmdbApi.navigatePage(userType, navigate);
          setMenuLearning(true);
        }

      }
      setActiveLoad("");
      console.log(response);


    } catch {
      //   setActiveLoad("")
      console.log("error");

    } finally {
      setBtnLoader("")
      setActiveLoad("")
    }
  };



  const handleForgot = (e) => {

    clentForgotPassword();

  }

  const fetchLibraryData = (id) => {
    // setLoading(true);
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    let params = {
      appname,
      // assetcount: itemsPerPage,
      // pageNumber: page,
      // search: searchQuery,
      // token: token,
      pageName: 'ACTIVE',
      type: "Learning Module",
      // moduleType:!type?"user":'all',
      userid: userid,
      moduleid: id

    }


    axios
      .get(`${lambda}/moduleInfo`, {
        params: params
      })
      .then((response) => {
        const result = response?.data?.result?.data;
        if (result === "Invalid token or Expired") {
          // handle invalid token if needed
          return;
        }
        if (result?.[0]?.purchased || result?.[0]?.subscribed === true || (result?.[0]?.purchased === false && result?.[0]?.cost === 0)) {

             navigate(`/moduleinstructions/${result?.[0]?.moduleid}`, {
                            state: { moduleType: "allmodules", moduleid: result?.[0]?.moduleid}
                        });
          // navigate(`/moduleslibrary/${id}`);
        } else {
          navigate("/moduleslibrary");
        }


      })
      .catch((err) => console.error("API error:", err))
    // .finally(() => );
  };
  console.log('/login/login/login/login/login/login', checkUserType)

  const onCancel = () => {
    setShowSessionPopup(false)
    setBtnLoader("")
  }
  const signoutsession = async () => {
    try {
      setBtnLoader("sessionLoad")
      const response = await tmdbApi.SignOutUser({ emailid: email });
      console.log(response);
      if (response?.result === "Success") {
        SigninPwd()

      } else {
        setError("Invalid Details");
        setBtnLoader("")
      }
    } catch {
      setBtnLoader("")
      console.log("error");
    } finally {
      setBtnLoader("")
      setActiveLoad("")
    }
  }


  const SigninPwd = async () => {
    setActiveLoad("loginpwd");
    try {
      let obj = {
        emailId: email,
        logintype: "password",
        password: pwd,
        userType: checkUserType ?? ""
      };

      if (localStorage.getItem("cpcid") && localStorage.getItem("cpcid") !== "null") {
        obj["cpcid"] = localStorage.getItem("cpcid");
      }

      const response = await tmdbApi.signin(obj);

      if (response.result && response.result.userid) {
        localStorage.setItem("cpcid", null);

        const userType = response?.result.userType;

        console.log('asdfasdfas df sd fas df as df as df', userType)
        const moduleid = localStorage.getItem("moduleid");
        const plan = localStorage.getItem("selectedPlan");
        const libraryId = localStorage.getItem("libraryId");

        localStorage.setItem("token", response.result.token);
        localStorage.setItem("email", email);
        console.log('response>>>>>>>>>>', response, email, appname)
        if (appname === "dadi") {
          window.clarity("set", "dadi_user_email", email)

        }
        localStorage.setItem("userId", response.result.userid);
        localStorage.setItem("userType", userType);
        localStorage.setItem("name", response?.result.name);
        localStorage.setItem("contact", response?.result.phoneNumber);

        localStorage.setItem("login", "setlogin");
        localStorage.setItem("freshLogin", "true"); // Prevent useEffect redirect
        const currentDate = new Date().toJSON();
        localStorage.setItem("currentSessionClientTime", currentDate);

        // Run common user data fetch
        GetUserDataContext();

        // Navigation logic
        if (userType === "DOCTOR") {

          if (moduleid && moduleid !== "null" && moduleid !== "undefined") {
            fetchLibraryData(moduleid);

            // navigate(`/moduleslibrary/${moduleid}`);
          }
          else if (plan && plan !== "null" && plan !== "undefined") {
            navigate("/fellowship");

          }
          else if (libraryId && libraryId !== "null" && libraryId !== "undefined") {
            navigate("/subscription");

          }
          else {
            tmdbApi.navigatePage(userType, navigate);
            setMenuLearning(true);
          }
        } else {
          tmdbApi.navigatePage(userType, navigate);
          setMenuLearning(true);

        }
      }
      else if (response.result === "Invalid email or password") {
        setError("Invalid email or password");
        setActiveLoad("");
        setTimeout(() => setError(""), 3000);
      }
      else if (response.result === "User not found") {
        setError("User not found");
        setActiveLoad("");
        setTimeout(() => setError(""), 3000);
      }
      else if (response.result === "Please log in using OTP and set a password") {
        setError("Please login using OTP and set a password");
        setActiveLoad("");
        setTimeout(() => setError(""), 3000);
      }
      else if (response.result === "Session Already Exists") {
        setShowSessionPopup(true);
        setBtnLoader("");
        setActiveLoad("");
      }
      else {
        setError("Invalid Details");
        setActiveLoad("");
        setTimeout(() => setError(""), 3000);
      }
    } catch {
      console.log("error");
    } finally {
      setBtnLoader("")
      setActiveLoad("")
    }
  };


  const handleClick = async (data) => {

    if (data === "otp") {

      const validate = emailValidation();

      if (validate) {
        setActiveLoad("otplogin")
        try {
          const response = await tmdbApi.signin({
            email: email,
            logintype: "otp",
          });

          if (response?.result === "Client not found") {
            setActiveLoad("")
            setError("Client not Found. Please SignUp ");
            setTimeout(function () { setError("") }, 3000);
          } else if (response.result === "PENDING VERIFICATION") {
            setError("Please Complete SignUp Process");
            setTimeout(function () { setError("") }, 3000);
            setActiveLoad("")
          } else if (response.result === "PENDING APPROVAL") {
            // setError("Please Wait For Admin Approval");
            // setTimeout(function () { setError("") }, 3000);
            navigate("/thankyou")
            setActiveLoad("")
          } else if (response.result === "INACTIVE") {
            setActiveLoad("")
            setError("User inactive. Please contact the administrator");
            setTimeout(() => {
              setError("");  // Clears the error after 3 seconds
            }, 3000);
          } else if (response.result === "User not found") {
            setError("User not found");
            setTimeout(function () { setError("") }, 3000);
            setActiveLoad("")
          } else {
            console.log(response);
            setActiveLoad("")
            setComponentType(data);
            // setShowOtp(true); // Move inside successful response handling
          }
        } catch (error) {
          console.log("error", error);
        }
        finally {
          setBtnLoader("")
          setActiveLoad("")
        }
      }
    } else {
      setComponentType(data);
    }

    console.log("componentTypeeeeeeeeeeeeeeeeeee", data);
  };


  useEffect(() => {
    if (checkUserType === "DOCTOR") {
      handleClick("otp")
    } else if (checkUserType === "ADMIN" || checkUserType === "PATHOLOGIST" || checkUserType === "LAB TECHNICIAN" || checkUserType === "TEACHING ADMIN" ) {
      handleClick("password")
    }
  }, [checkUserType])


  const handleCheckType = async (emailValue) => {

    const validate = emailValidation();

    if (validate) {
      setActiveLoad("NextLogin")

      try {
        const params = {
          appname,
          emailid: emailValue,
        };

        const response = await axios.get(`${lambda}/userInfo`, { params });
        const result = response?.data?.result;

        console.log("API Response:", response);
        console.log("Result Data:", result);
        setActiveLoad("")
        if (result === "Invalid token or Expired") {
          // Handle invalid token (e.g., logout, show message, etc.)
          console.warn("Invalid or expired token.");
          return;
        } else if (result.length > 0) {
          setCheckUserType(result?.[0]?.userType)
        } else {
          setError("User not Found");
          setTimeout(function () { setError("") }, 3000);
        }

        // ✅ Do something with the result here if needed
        return result;

      } catch (error) {
        console.error("API Error:", error.message || error);
      } finally {
        setActiveLoad("")
      }
    }
  };


  const handleChange = (otp) => {
    setSigninOtp(otp)
    setOtpClass(false);
  }



  const handleResendOtp = async () => {

    setResendActive(true)
    setTimeout(function () {
      setResendActive(false)
    }, 3000)
    // setOtpClass(true)
    try {
      //   console.log(tmdbApi);
      const response = await tmdbApi.resendOtp({
        "emailId": email,
        "logintype": "otp",

      });
      // setResendActive(false)
      console.log(response);
    } catch {
      setResendActive(false)

      console.log("error");
    } finally {
      setBtnLoader("")
      setResendActive(false)
      setActiveLoad("")
    }
  };
  const handleClose = () => {
    if (componentType === "frgtpwd") {
      setVisibility({ ...visibility, showpassword: false })
      setComponentType("password")
    } else if (componentType === "recoverotp") {
      setComponentType("frgtpwd")
    } else if (componentType === "verify") {
      setComponentType("recoverotp")

    } else {
      setComponentType("")
      localStorage.removeItem("fellowshipInterest");
      localStorage.removeItem("fellowshipInterestDate");
      setVisibility({ ...visibility, newpwd: false, cnfrmpwd: false })
      navigate("/")
    }

  }
  const handleLogin = (type) => {
    if (type === "otp") {
      if (signinOtp === "") {
        setOtpClass(true)
      } else {
        setActiveLoad("confirmotp")
        signOtp()
      }

    } else {
      handleSignIn()
    }
  }

  return (
    <>
      <Modal className="access-denied" show={showSessionPopup} id="accessDeniedModal">
        <div className="modal-body enquiry-form">
          <div className="container">
            <button className="close-btn" onClick={e => onCancel()} id="closeSessionPopupBtn">
              <span className="material-icons">close</span>
            </button>
            <span className="material-icons access-denied-icon" id="sessionIcon">
              web_asset_off
            </span>
            <h3 id="sessionTitle">Multiple Sessions Found</h3>
            <p id="sessionDescription">Another session is running in another browser. Do you want to terminate that session?</p>
            <div className="popup-footer">
              <button
                className="fill_btn yellow-gradient"
                data-bs-toggle="modal"
                data-bs-target="#recommendModal"
                onClick={e => signoutsession()}
                id="terminateSessionBtn">
                {BtnLoader === "sessionLoad" ? (
                  <img src={rotate_right} className="loading-icon" />
                ) : null}
                Yes
              </button>
              <button className="fill_btn" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={e => onCancel()} id="cancelSessionBtn">
                No
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <div className="signin-wrapper" id="signinWrapper">
        <div className="logo_section" id="logoSection">
          <img src={logo} className="logo" id="logoImage" />
          <button className="close-btn" id="closeSigninBtn" onClick={handleClose}>
            <span className="material-icons" >close</span>
          </button>
        </div>
        <div className="signin-body" id="signinBody">
          <div className="signin-graphic" id="signinGraphic">
            <img src={signinImage} id="signinGraphicImage" />
            <h3 id="signinHeading">Seamless Onboarding</h3>
            <p id="signinSubheading">Quick and smooth access for doctors to begin their quiz journey.</p>
          </div>

          {componentType === "otp" ? (
            <div className="signin-section emaillogin" id="otpSection">
              <h1 className="bold-heading" id="otpHeading">Login With OTP</h1>
              <p className="mb-2" id="otpInstruction">Please enter the OTP (One-Time Password) send to your registered email <span className="email-show-txt" id="otpEmail">{email}</span> to complete your verification</p>
              <div className="otp-blocks mt-4 mb-4" id="otpBlocks">
                <div className={otpclass ? "otp-inputs block-margin signup-otp-inputs invalid errorStyle" : "otp-inputs block-margin"} id="otpInputs">
                  <OTPInput value={signinOtp} onChange={handleChange} autoFocus OTPLength={5} otpType="number" id="otpInputField" />
                </div>
                {/* {signinOtp === "" ? (
                  
                    <span id="otpError" className="errormsg" >Please enter valid otp</span>
                  ) : (
                    <span id="otpErrorMessage" className="errormsg" >The OTP you have entered is incorrect. Please try again or request a new OTP</span>
                  )} */}
                {otpclass && <span id="otpErrorMessage" className="errormsg" >The OTP you have entered is incorrect. Please try again or request a new OTP</span>}
                <button className="resend-button reset-quiz-btn-1" onClick={handleResendOtp} id="resendOtpBtn">
                  Resend OTP
                </button>
                {resendActive ? (
                  <p style={{ 'font-size': '12px', 'color': 'green', 'position': 'absolute', 'left': '80px', 'bottom': '-29%' }} id="otpResentMessage">
                    OTP Resent!
                  </p>
                ) : null}
              </div>
              <div className="signin-footer mt-2" id="otpFooter">
                <button className="btn-fill" disabled={activeLoad === "confirmotp"} onClick={() => handleLogin("otp")} id="otpLoginBtn">

                  {activeLoad === "confirmotp" ? (
                    <img src={rotate_right} className="loading-icon" id="forgotPasswordLoading" />
                  ) : null}LOGIN
                </button>
                {/* <button className="outline_btn reset-quiz-btn" onClick={() => handleClick("password")} id="loginWithPasswordBtn">
                  LOGIN with password
                </button> */}
              </div>
              <span className="errormsg" id="otpErrorMessageSpan"></span>
            </div>
          ) : componentType === "password" ? (
            <div className="signin-section emaillogin" id="passwordSection">
              <h1 className="bold-heading" id="passwordHeading">Log in to your Account</h1>
              <p id="passwordInstruction">Enter your email to log in using either your password or a one-time password (OTP)</p>


              <div className="input_group_wrapper">
                <label className="form_label">Email</label>
                <div className="input_group">
                  <div className="icon_wrapper">
                    <span className="material-symbols-outlined">mail</span>
                  </div>
                  <input type="text" className="form-control" id="usernameInput" value={email} disabled onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
                </div>
              </div>


              <div className="input_group_wrapper mt-3">
                <label className="form_label">Password</label>
                <div className="input_group">
                  <div className="icon_wrapper">
                    <span className="material-symbols-outlined">lock</span>
                  </div>
                  <input type={visibility?.showpassword ? "text" : "password"}
                    className="form-control padding-right"
                    id="passwordInput"
                    onChange={(e) => setPwd(e.target.value)}
                    placeholder="Password"
                    onKeyPress={handleKeypress} />


                  <span id="togglePasswordVisibility" onClick={() => setVisibility((prev) => ({ showpassword: !prev.showpassword }))} className="material-symbols-outlined lock-style">{visibility.showpassword ? "visibility_off" : "visibility"}</span>
                </div>

              </div>

              <p className="signup-prompt mt-3 d-flex" id="rememberPassword">
                <input type="checkbox" className="me-2" id="rememberPasswordCheckbox" />
                Remember Password
                <a className="ms-auto forgot-style" onClick={() => handleForgot()} id="forgotPasswordLink">
                  {activeLoad === "forgotpwd" ? (
                    <img src={rotate_right} className="loading-icon" id="forgotPasswordLoading" />
                  ) : null}
                  Forgot Password ?
                </a>
              </p>

              {error ? <span className="errormsg" id="errormessage" style={{
              }}>{error}</span> : ""}
              <div className="signin-footer mt-3" id="passwordFooter">

                <button className="outline_btn reset-quiz-btn" disabled={activeLoad === "otplogin"} onClick={() => handleClick("otp")} id="passwordLoginWithOtpBtn">
                  {activeLoad === "otplogin" ? (
                    <img src={rotateIconorange} className="loading-icon" id="otpLoginLoading" />
                  ) : null}
                  Login with OTP
                </button>
                <button className="btn-fill" disabled={activeLoad === "loginpwd"} onClick={() => handleLogin("password")} id="passwordLoginBtn">
                  {activeLoad === "loginpwd" ? (
                    <img src={rotate_right} className="loading-icon" id="loginPwdLoading" />
                  ) : null}
                  Login
                </button>
              </div>

              <p className="signup-prompt mt-3" id="createAccountPrompt">
                Don’t have an account?
                <a className="mx-2" style={{ cursor: 'pointer' }} onClick={() => { navigate('/signup') }} id="createAccountLink">
                  Create an Account
                </a>
              </p>
            </div>
          ) : (
            <div className="signin-section emaillogin" id="defaultSection">
              <h1 className="bold-heading" id="defaultHeading">Log in to your Account</h1>
              <p id="defaultInstruction">Please enter your email to log in using OTP or password</p>
              <div className="input_group_wrapper">
                <label className="form_label">Email</label>
                <div className="input_group">
                  <div className="icon_wrapper">
                    <span className="material-symbols-outlined">mail</span>
                  </div>
                  <input type="text" className="form-control" id="emailInput" value={email}
                    onChange={(e) => { setEmail(e.target.value); setError(""); }} placeholder="Email" />

                </div>
                {error ? (
                  <span className="errormsg" style={{

                  }} id="defaultError">
                    {error}
                  </span>
                ) : ""}
              </div>


              <div className="signin-footer mt-4" id="defaultFooter">
                {checkUserType === "DOCTOR" ?
                  <button className="outline_btn reset-quiz-btn login-pop" disabled={activeLoad === "otplogin"} onClick={() => handleClick("otp")} id="defaultOtpLoginBtn">
                    {activeLoad === "otplogin" ? (
                      <img src={rotateIconorange} className="loading-icon" id="OtpLoginLoading" />
                    ) : null}
                    OTP Login
                  </button>
                  : checkUserType === "ADMIN" ?
                    <button className="btn-fill" disabled={activeLoad === "pwdlogin"} onClick={() => handleClick("password")} id="PasswordLoginBtn">
                      {activeLoad === "pwdlogin" ? (
                        <img src={rotate_right} className="loading-icon" id="PasswordLoginLoading" />
                      ) : null}
                      Password Login
                    </button> :


                    <button className="btn-fill" disabled={activeLoad === "nextlogin"} onClick={() => handleCheckType(email)} id="NextdLoginBtn">
                      {activeLoad === "nextlogin" ? (
                        <img src={rotate_right} className="loading-icon" id="NextLoginLoading" />
                      ) : null}
                      Continue
                    </button>}
              </div>

              <p className="signup-prompt mt-4" id="CreateAccountPrompt">
                Don’t have an account?
                <a className="mx-2" style={{ cursor: 'pointer' }} onClick={() => { navigate('/signup') }} id="CreateAccountLink">
                  Create an Account
                </a>
              </p>
            </div>
          )}
        </div>
      </div>

      <footer className="login_footer" id="loginFooter">
        <div className="container-fluid">
          <p className="footer-para me-4" id="footerText">© 2025 Dadi. All rights reserved.</p>
          <p className="footer-para"><a href="/privacy" className="me-2">Privacy</a> <a href="/terms" data-discover="true">Terms of Use</a></p>
        </div>
      </footer>

      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
        id="toastContainer"
      />


    </>

  );
};

export default SignIn;
